import BodyLogo from "./BodyLogo";
import {
  DropdownMenu,
  DropdownMenuPortal,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "@radix-ui/react-dropdown-menu";
import { MenuIcon } from "lucide-react";
import Button from "../Button";
import { useState } from "react";
import { useUser } from "@clerk/clerk-react";
import { SignInButton, UserButton } from "../Auth";
import { Link as RouterLink } from "react-router-dom";

type BodyHeaderProps = {
  hasChanges: boolean;
  onRefresh: () => void;
  onRun: () => void;
};

const Link = ({
  href,
  children,
  localHref,
  target,
  className,
}: {
  href: string;
  children: React.ReactNode;
  localHref?: string;
  target?: string;
  className?: string;
}) => {
  const isLocalHost = window.location.hostname === "localhost";

  return (
    <a
      href={isLocalHost ? localHref : href}
      target={target || "_self"}
      rel="noopener noreferrer"
      className={
        className ??
        "text-text-primary cursor-pointer hover:underline underline-offset-4"
      }
    >
      {children}
    </a>
  );
};

const BodyHeader = ({ hasChanges, onRun, onRefresh }: BodyHeaderProps) => {
  const { isSignedIn, isLoaded } = useUser();

  return (
    <div className="pt-4 md:pt-2 px-2 md:px-0 md:pl-2 flex justify-between items-end md:mb-3 flex-wrap md:flex-nowrap">
      <span className="flex items-center gap-3">
        <BodyLogo />
        <span className="text-[28px] font-semibold leading-9 tracking-[0.34px] text-text-primary">
          Script Editor
        </span>
        {
          <div
            className={`w-[15px] h-[15px] rounded-full mt-1 ${hasChanges ? "bg-pluto-success" : "bg-pluto-neutral"}`}
          />
        }
      </span>

      <div className="flex items-center gap-4 pr-4">
        <nav className="hidden md:flex items-center gap-5">
          <RouterLink
            to="/"
            className="text-text-primary cursor-pointer hover:underline underline-offset-4"
          >
            Home
          </RouterLink>
          {/* <RouterLink
            to="/pricing"
            className="text-text-primary cursor-pointer hover:underline underline-offset-4"
          >
            Pricing
          </RouterLink> */}
          <Link
            href="https://docs.pluto.xyz"
            localHref="https://docs.pluto.xyz"
            target="_blank"
            className="text-text-primary cursor-pointer hover:underline underline-offset-4"
          >
            Documentation
          </Link>
        </nav>
        {/* {isLoaded && <>{isSignedIn ? <UserButton /> : <SignInButton />}</>} */}
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <button className="cursor-pointer outline-0 border-0 mr-2 md:hidden">
              <MenuIcon className="w-8 h-8" />
            </button>
          </DropdownMenuTrigger>

          <DropdownMenuPortal>
            <DropdownMenuContent
              className="bg-white py-2 shadow-lg rounded-sm DropdownMenuContent"
              side="bottom"
              align="end"
              sideOffset={2}
            >
              <DropdownMenuLabel />
              <DropdownMenuItem
                className="text-lg px-4 cursor-pointer outline-0 hover:underline underline-offset-4 md:hidden"
                onSelect={onRefresh}
              >
                Reset Script
              </DropdownMenuItem>
              <DropdownMenuSeparator className="md:hidden my-1 h-px bg-gray-200" />
              <DropdownMenuItem className="text-lg px-4 cursor-pointer outline-0 hover:underline underline-offset-4">
                <RouterLink to="/">Home</RouterLink>
              </DropdownMenuItem>
              {/* <DropdownMenuItem className="text-lg px-4 cursor-pointer outline-0 hover:underline underline-offset-4">
                <RouterLink to="/pricing">Pricing</RouterLink>
              </DropdownMenuItem> */}
              <DropdownMenuItem className="text-lg px-4 cursor-pointer outline-0 hover:underline underline-offset-4">
                <Link
                  href="https://docs.pluto.xyz"
                  localHref="https://docs.pluto.xyz"
                >
                  Documentation
                </Link>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenuPortal>
        </DropdownMenu>
      </div>
    </div>
  );
};

export default BodyHeader;
export { BodyHeader };
